<template>
    <el-tabs v-model="activeName">
      <el-tab-pane
        v-for="(item, itemIdx) in tabs"
        :key="item.id"
        :label="item.name"
        :name="item.id"
        :lazy="itemIdx !== 0"
      >
      <template #label>
          <div class="category-column">
            <img
              v-show="item.url && item.id !== activeName"
              class="category-item-icon"
              :key="`${itemIdx}-img`"
              :src="item.url"
              alt=""
            />
            <img
              v-show="item.activeUrl && item.id === activeName"
              class="category-item-icon active"
              :key="`${itemIdx}-img1`"
              :src="item.activeUrl"
              alt=""
            />
            <span class="category-item-title">{{ item.name }}</span>
          </div>
        </template>
        <div>
          <TopicChildArticleListItem
            :topic-config="config"
            :category-conf="item"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </template>
  
  <script setup>
  import { ref, watch, onMounted, onBeforeUnmount, computed } from 'vue';
  import { getArticleCategoryList } from '@/api/index';
  
  import TopicChildArticleListItem from './TopicChildArticleListItem.vue';
  import {find,sortBy} from 'lodash-es';
  
  import useLocate from "../uses/useLocate.js";

  let { langJson, nowLocale, getLocaleText } = useLocate();
  // 获取本地化文本方法
 
  
  // 接受传递的 prop
  const props = defineProps({
    allArcListMap: {
    type: Object,
    default: () => ({})
  },
  currentElementIndex: {
    type: Array,
    default: () => []
  },
  idx: {
    type: Number,
    default: -1
  },
    parentKeys: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
    },
  });
  
  // 响应式数据
  const tabs = ref([]);
  const activeName = ref('');
  const pageNo = ref(0);
  
  // 计算属性
  const edit = computed(() => !props.disabled);
  
  // 数据获取函数
  const fetchDataFunc = async () => {
    try {
      const response = await getArticleCategoryList({
        topicId: props.config.themeId,
        pageNo: pageNo.value,
        status: 1,
        pageSize: 10000,
      });
  
      let setTabs = response.data.dataList.map((o) => {
        let findItem =  find(props.config.categoryConfigs, (conf) => conf.id === o.id) || {};
        return { ...findItem, ...o };
      });
  
      setTabs =  sortBy(setTabs, 'sort');
      tabs.value = setTabs;
  
      if (tabs.value.length) {
        activeName.value = tabs.value[0].id;
      }
    } catch (e) {
      console.log(e);
    }
  };
  
  // watch 监听
  watch(
    () => props.config.categoryConfigs,
    (newVal) => {
      if (! find(newVal, (o) => o.id === activeName.value)) {
        activeName.value = newVal[0]?.id || '';
      }
    },
    { deep: true }
  );
  
  // 生命周期钩子
  onMounted(() => {
    fetchDataFunc();
    if (typeof window !== 'undefined') {
      if (!window.topicPageTabs) {
        window.topicPageTabs = {};
      }
      window.topicPageTabs[props.config.id] = {
        setTab,
        getTab,
      };
    }
  });
  
  onBeforeUnmount(() => {
    if (typeof window !== 'undefined' && window.topicPageTabs) {
      delete window.topicPageTabs[props.config.id];
    }
  });
  
  // 方法
  const setTab = (i) => {
    if (props.config.categoryConfigs[i]) {
      activeName.value = props.config.categoryConfigs[i].title + i;
    }
  };
  
  const getTab = () => {
    return activeName.value;
  };
  </script>
  
  <style scoped>
  .category-column {
    display: flex;
    align-items: center;
  }
  .category-item-icon {
    width: 2rem;
    height: 2rem;
  }
  .category-item-title {
    margin-left: 10px;
  }
  </style>
  